module.exports = __webpack_public_path__ + "img/addone_ban.png";